<template>
  <Dialog
    :model="showAlertPop"
    :closeable="false"
    @alertOnClose="closeMe"
  >
    <span class="alert-title">温馨提示</span>
    <article class="alert-content">
      目前非取款开放时间， 如有需要可联系我司24小时客服。
    </article>
    <div v-if="canWithdraw.usdt || canWithdraw.bank" class="alert-bottom">
      <button type="button" class="alert-button" @click="continueWithdraw">
        继续{{ canWithdraw.bank ? '银行卡' : canWithdraw.usdt ? '电子钱包' : '' }}取款
      </button>
      <button type="button" class="alert-button alert-cancel" @click="goBack">
        返回上一页
      </button>
    </div>
    <div v-else class="alert-bottom">
      <button type="button" class="alert-button alert-cancel" @click="goBack">
        返回上一页
      </button>
    </div>
  </Dialog>
</template>
<script>
import Dialog from '@/view/module/Dialog.vue'
import { mapState } from 'vuex'
export default {
  name: 'NewCanWithdrawalModule',
  components: {
    Dialog
  },
  props: ['showAlertPop', 'alertOnClose', 'canWithdraw'],
  data() {
    return {}
  },
  computed: {
    ...mapState(['pageType'])
  },
  methods: {
    continueWithdraw() {
      this.$emit('alertOnClose')
    },
    closeMe() {
      this.$emit('alertOnClose')
    },
    goBack() {
      if (this.pageType === 'app') this.$router.go(-1)
      else this.$router.replace({ path: '/home' })
    }
  }
}
</script>
